var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridItem',{attrs:{"image":_vm.vendor.images_sizes['207x207'],"url":("/merchants/" + (_vm.vendor.id)),"padding":5,"id":_vm.vendor.id}})}
var staticRenderFns = []

export { render, staticRenderFns }